<template>
  <account-login platform="portal"/>
</template>

<script>
import AccountLogin from '../../components/assemble-account/AccountLogin';

export default {
  name: 'Login',
  components: {
    'account-login': AccountLogin
  }
};
</script>

<style scoped lang="scss">
</style>
